<script setup lang="ts">
const paginationContext = usePaginationContext();
const theme = usePaginationTheme();
</script>

<template>
  <div>
    <nav
      :id="paginationContext.paginationId.value"
      class="pagination__nav"
      role="navigation"
      :aria-label="$t('Pagination.Aria.Pagination', { totalPages: paginationContext.totalPages.value })"
    >
      <ul :class="theme.list()">
        <li
          v-if="paginationContext.showFirstAndLastButtons"
          :class="theme.item()"
        >
          <slot name="first-button">
            <PaginationFirst />
          </slot>
        </li>
        <li :class="theme.item()">
          <slot name="prev-button">
            <PaginationPrev />
          </slot>
        </li>

        <slot name="numbers">
          <PaginationNumbers />
        </slot>

        <li :class="theme.item()">
          <slot name="next-button">
            <PaginationNext />
          </slot>
        </li>
        <li
          v-if="paginationContext.showFirstAndLastButtons"
          :class="theme.item()"
        >
          <slot name="last-button">
            <PaginationLast />
          </slot>
        </li>
      </ul>
      <slot name="robots-links">
        <PaginationRobotLinksList />
      </slot>
    </nav>
    <slot name="page-size">
      <PaginationPageSize v-if="paginationContext.allowPageSizeChange" />
    </slot>
  </div>
</template>
